import { render, staticRenderFns } from "./SelectPopulado.vue?vue&type=template&id=0366fad4&"
import script from "./SelectPopulado.vue?vue&type=script&lang=js&"
export * from "./SelectPopulado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports